import {createStore, compose, applyMiddleware} from "redux";
import {thunk} from "redux-thunk";

import rootReducer from "./index";

let isDev = true

const composeEnhancers = isDev ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

export const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk))
);
